import React from 'react'
/* DYNAMIC IMPORTS */
import importer from '@takedapdt/biolife-core/src/importer'
/* COMPONENTS */
const CenterNotFound = importer('Components/CenterNotFound')

const NoCenterFound = ({}) => <CenterNotFound />
export default NoCenterFound
